import React, { useState, useRef, useEffect } from 'react';

export default function RichTextCell({ value }) {
  const [showPreview, setShowPreview] = useState(false);
  const clickTimer = useRef(null);

  if (!value) return <span />;

  const handleClick = () => {
    // Wait 300ms to see if a double-click follows
    if (clickTimer.current) clearTimeout(clickTimer.current);
    clickTimer.current = setTimeout(() => {
      clickTimer.current = null;
      setShowPreview(true);
    }, 300);
  };

  const handleDoubleClick = () => {
    // Cancel the preview - let the parent's double-click (edit) take over
    if (clickTimer.current) {
      clearTimeout(clickTimer.current);
      clickTimer.current = null;
    }
  };

  useEffect(() => {
    if (!showPreview) return;
    const handleKey = (e) => { if (e.key === 'Escape') setShowPreview(false); };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [showPreview]);

  // Cleanup timer on unmount
  useEffect(() => {
    return () => { if (clickTimer.current) clearTimeout(clickTimer.current); };
  }, []);

  return (
    <>
      <div
        className="cm-cell-richtext"
        onClick={handleClick}
        onDoubleClick={handleDoubleClick}
        dangerouslySetInnerHTML={{ __html: value }}
      />
      {showPreview && (
        <div className="cm-modal-overlay" onClick={() => setShowPreview(false)}>
          <div className="cm-modal-richtext cm-modal-richtext--preview" onClick={e => e.stopPropagation()}>
            <div className="cm-modal-richtext__header">
              <span className="cm-modal-richtext__title">Contenido</span>
              <button className="cm-modal-richtext__close" onClick={() => setShowPreview(false)}>
                <i className="fas fa-times" />
              </button>
            </div>
            <div className="cm-modal-richtext__body cm-modal-richtext__body--preview">
              <div className="cm-richtext-preview" dangerouslySetInnerHTML={{ __html: value }} />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
